// extracted by mini-css-extract-plugin
export var burgerMenuContainer = "burgermenu-module--burgerMenuContainer--6b60f";
export var dropdownContent = "burgermenu-module--dropdown-content--36e95";